import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    invalidValue: translate({ id: 'components.loadList.loads.noValidValue' }),
    invalidName: translate({ id: 'components.loadList.loads.noValidName' }),

    loadName: translate({ id: 'order.form.bulk.loads.loadName.label' }),
    loadValue: translate({ id: 'order.form.bulk.loads.loadValue.label' }),

    addLoad: translate({ id: 'order.form.bulk.loads.addLoadsModalTitle' }),
    deleteLoadTooltip: translate({
      id: 'global.remove',
    }),

    newLoadWarningTooltip: translate({ id: 'orders.edit.validation.loads.newLoadWarningTooltip' }),
  }))

  return api
}
